import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90svh] md:min-h-screen flex flex-col items-center justify-center px-4 py-12 md:py-20 overflow-hidden" data-id="element-278">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-279">
        <img src="https://cdn.magicpatterns.com/uploads/vc7GbfXVSCBdWP7Y2J85y7/heylloyd-image-1772856075494.png" alt="Roofing background" className="w-full h-full object-cover opacity-15" data-id="element-280" />
        <div className="absolute inset-0 bg-gradient-to-b from-carbon/80 via-carbon/95 to-carbon" data-id="element-281"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center w-full" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full max-w-2xl mb-8 md:mb-10 rounded-xl overflow-hidden shadow-[0_0_30px_rgba(242,183,5,0.1)] border border-dark-border" data-id="element-283">
          <img src="https://cdn.magicpatterns.com/uploads/cQ2KyihB4hxYvUWNUFZc62/heylloyd-image-1772856075494.png" alt="Profesional de Roofing en el techo con herramientas digitales" className="w-full h-[200px] md:h-[320px] object-cover" data-id="element-284" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 1,
        scaleX: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="w-16 h-1 bg-gold mb-6 rounded-full" data-id="element-285" />

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-2xl md:text-4xl lg:text-5xl font-heading font-extrabold text-gold text-center leading-tight mb-6 md:mb-8" data-id="element-286">
          ¿Sigues pagando por leads que ya llamaron a 5 competidores antes que a
          ti?
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full max-w-3xl mb-10 md:mb-12 space-y-6 text-center" data-id="element-287">
          <p className="text-base md:text-xl text-white leading-relaxed" data-id="element-288">
            Deja de ser un esclavo de HomeAdvisor, Angi y Yelp. Si tu negocio de
            Roofing depende de que un tercero te 'venda' un cliente que ya está
            comparando precios con otros 4,{' '}
            <strong className="text-white font-bold" data-id="element-289">
              no tienes un negocio, tienes una lotería.
            </strong>
          </p>
          <p className="text-base md:text-xl text-white leading-relaxed" data-id="element-290">
            Instalamos tu propio{' '}
            <strong className="text-white font-bold" data-id="element-291">
              Sistema de Adquisición Blindado
            </strong>
            : Clientes exclusivos que solo te llaman a TI. No más subastas. No
            más competir por precio. Solo contratos de alto margen.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col items-center w-full" data-id="element-292">
          <CTAButton text="QUIERO MIS PROPIOS LEADS EXCLUSIVOS" scrollTo="contact-form" className="w-full md:w-auto text-base md:text-lg shadow-[0_0_20px_rgba(242,183,5,0.2)]" data-id="element-293" />
          <p className="text-gray-sec text-xs md:text-sm mt-4 text-center" data-id="element-294">
            Auditoría de zona gratuita. 15 minutos.
          </p>
          <div className="mt-4" data-id="element-295">
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline text-sm font-medium" data-id="element-296">
              O agenda directamente →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}